export default `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="3" fill="#FE8FA0"/>
<ellipse cx="15.5" cy="16" rx="10.5" ry="9" fill="white"/>
<circle cx="9.5" cy="8.5" r="2.5" fill="white"/>
<circle cx="21.5" cy="8.5" r="2.5" fill="white"/>
<circle cx="11" cy="13" r="1" fill="#FE8FA0"/>
<circle cx="19" cy="13" r="1" fill="#FE8FA0"/>
<ellipse cx="15.5" cy="19" rx="4.5" ry="3" fill="#FE8FA0"/>
<ellipse cx="15.5" cy="18" rx="1.5" ry="1" fill="white"/>
</svg>
`;
